{
  "de": {
    "mainFobizzNavbar": {
      "a11y": {
        "actions": "Aktionen",
        "closeNavigation": "Navigation schließen",
        "mainNav": "Hauptnavigation",
        "openNavigation": "Navigation öffnen",
        "skipToContent": "Zum Inhalt springen",
        "closeFlyout": "Flyout schließen"
      },
      "login": "Einloggen",
      "logoHint": "Hier geht's zur Startseite zurück",
      "myfobizz": {
        "headers": {
          "adminArea": "Admin Bereich 🤓",
          "myfobizz": "Mein fobizz"
        },
        "links": {
          "backofficePlatform": "Backoffice",
          "contact": "Hilfe und Kontakt",
          "folders": "Meine Ablage",
          "histories": "Meine Historie",
          "news": "Neuigkeiten",
          "partnersOverview": "Übersicht Partner",
          "profile": "Mein Profil",
          "features": "Feature Flags",
          "reviewerSection": "Reviewer Section",
          "subscriptions": "Meine Lizenzen",
          "timetable": "Stundenplan",
          "toTeach": "Zu to teach"
        }
      },
      "navbarSearch": {
        "placeholder": "Schnelleinstieg",
        "results": {
          "courses": "Fortbildungen",
          "empty": "Keine Ergebnisse",
          "materials": "Unterrichtsmaterialien",
          "myContent": "Meine Ablage",
          "schoolClassesAndProjects": "Klassenräume und Projekte",
          "sharedLibrary": "Gemeinsame Ablage",
          "showAll": "Alle anzeigen",
          "showAllSchoolClasses": "Zu den Klassenräumen",
          "showAllSharedLibrary": "Zur Gemeinsamen Ablage",
          "showAllTools": "Zu den Tools",
          "showAllWithCount": "Alle {count} anzeigen",
          "tools": "Tools"
        }
      },
      "breadcrumb": {
        "tools": "Tools"
      },
      "pupilLogin": {
        "text": "Arbeite mit der KI-Assistenz und Unterrichtsmaterialien. Deinen individuellen Zugang erhältst du von deiner Lehrkraft.",
        "title": "Als Schüler*in einloggen"
      },
      "signup": {
        "text": "Erstelle ein kostenloses Konto und erhalte eingeschränkten Zugang zu Fortbildungen, Unterrichtsmaterialien und Tools.",
        "title": "Registrieren"
      },
      "teacherLogin": {
        "text": "Erstelle und verwalte Unterrichtsmaterialien für deine Klasse und schalte die KI für eure Projekte frei.",
        "title": "Als Lehrkraft einloggen"
      },
      "tooltips": {
        "homepage": "Zur Startseite",
        "myfobizz": "Mein fobizz",
        "search": "Schnelleinstieg in alle Fortbildungen und Unterrichtsmaterialien"
      },
      "coachmarkTour": {
        "title": "Neue Navigation",
        "next": "Weiter",
        "done": "Fertig",
        "steps": {
          "step1": "Mit der neuen Navigation erreichst du die wichtigsten Bereiche und Funktionen jetzt noch schneller.",
          "step2": "Unter Organisieren findest du deine Ablage, Klassenräume und Stundenpläne zentral an einem Ort.",
          "step3": "Über deinen Avatar behältst du deinen Lizenz-Status im Blick und gelangst zu weiteren wichtigen Informationen."
        }
      },
      "sharedLibraryHint": {
        "title": "NEU: Gemeinsame Ablage",
        "headline": "Material gemeinsam nutzen",
        "body": "Lege Inhalte in der Gemeinsamen Ablage ab, damit ihr sie im Kollegium nutzen könnt. Wie ein digitaler Materialschrank.",
        "confirm": "Ok"
      },
      "licenseInfo": {
        "summary": "{type}: {areas}",
        "types": {
          "einzel": "Einzellizenz",
          "schul": "Schullizenz"
        },
        "areas": {
          "courses": "Fortbildungen",
          "tools": "Tools",
          "toTeach": "to teach"
        },
        "limited": "Limitierte Nutzung (Upgrade)"
      },
      "offcanvas": {
        "headers": {
          "organize": "Organisieren",
          "mySchool": "Meine Schule",
          "settings": "Einstellungen",
          "partners": "Partner"
        },
        "links": {
          "sharedLibrary": "Gemeinsame Ablage",
          "classes": "Klassenräume",
          "schoolOverview": "Übersicht",
          "licenseManagement": "Lizenzverwaltung",
          "internalWorkshops": "Interne Workshops",
          "authorArea": "Autorenbereich"
        }
      },
      "tabs": {
        "start": "Start",
        "organize": "Organisieren",
        "tools": "Tools",
        "material": "Material",
        "partner": "Partner",
        "courses": "Fortbilden"
      },
      "flyout": {
        "organize": {
          "folders": {
            "headline": "Meine Ablage",
            "description": "Deine Materialien an einem Ort",
            "linkLabel": "Zur Ablage"
          },
          "sharedLibrary": {
            "headline": "Gemeinsame Ablage",
            "description": "Material mit deiner Schulgruppe teilen",
            "linkLabel": "Zur Ablage"
          },
          "classes": {
            "headline": "Klassenräume",
            "description": "Klassen anlegen und mit SuS arbeiten",
            "linkLabel": "Klassenraum erstellen",
            "linkLabelPopulated": "Alle anzeigen"
          },
          "timetable": {
            "headline": "Stundenplan",
            "description": "Stunden planen und Material verknüpfen",
            "linkLabel": "Stundenplan erstellen",
            "linkLabelPopulated": "Anzeigen",
            "todayTime": "heute, {time}"
          }
        },
        "material": {
          "partner": {
            "headline": "fobizz & Partner",
            "description": "Materialien von fobizz und Partnern",
            "linkLabel": "Material entdecken"
          },
          "toTeach": {
            "headline": "Inhalte",
            "description": "Materialien von to teach",
            "linkLabel": "Material entdecken"
          },
          "community": {
            "headline": "fobizz Community",
            "description": "Materialien der fobizz Community",
            "linkLabel": "Material entdecken"
          },
          "bookmarks": {
            "headline": "Merkliste",
            "description": "Gemerkte Materialien",
            "linkLabel": "Zur Merkliste"
          }
        },
        "tools": {
          "aiChat": {
            "headline": "KI Chat und Assistenten",
            "items": {
              "chat": "KI Chat",
              "assistants": "KI-Assistenten Katalog",
              "miniTool": "Promptlabor"
            }
          },
          "multimedia": {
            "headline": "KI Multimedia Tools",
            "items": {
              "image": "Bild generieren",
              "podcast": "Podcast",
              "transcript": "Transkript"
            }
          },
          "material": {
            "headline": "Material anlegen",
            "items": {
              "worksheet": "Arbeitsblatt",
              "classroomScreen": "Digitale Tafel",
              "survey": "Umfrage"
            }
          },
          "share": {
            "headline": "Inhalte teilen",
            "items": {
              "fileSharing": "Dateien teilen",
              "qrCode": "QR-Code",
              "linkShortener": "Link kürzen"
            }
          },
          "showAll": "Alle anzeigen",
          "showAllTools": "Alle Tools anzeigen"
        },
        "start": {
          "stats": {
            "fortbildungen": "Fortbildung | Fortbildungen",
            "materialien": "Material | Materialien",
            "klassen": "Klasse | Klassen",
            "prompts": "Prompt | Prompts"
          }
        },
        "courses": {
          "catalog": {
            "headline": "Kurskatalog",
            "liveWebinare": "Live-Webinare",
            "fortbildungen": "Fortbildungen",
            "linkLabel": "Zum Kurskatalog"
          },
          "myCourses": {
            "headline": "Meine Fortbildungen",
            "descriptionEmpty": "Du hast keine aktiven Fortbildungen und Zusatzqualifikationen",
            "activeCount": "Aktive Fortbildungen ({count})",
            "bookmarkedCount": "Gemerkte Fortbildungen ({count})",
            "linkLabel": "Zu meinen Fortbildungen",
            "linkLabelEmpty": "Fortbildungen entdecken"
          },
          "additionalQualifications": {
            "headline": "Zusatzqualifikationen",
            "description": "Jetzt anmelden für die neuen ZQ’s im Schuljahr 2026/2027",
            "linkLabel": "Zur Infoseite"
          },
          "aiLiteracyTraining": {
            "headline": "AI Literacy Training",
            "description": "Nimm an unserem kostenlosen Online-Training zu KI-Kompetenz für Lehrkräfte teil.",
            "linkLabel": "Mehr erfahren & anmelden"
          }
        }
      },
      "mobileNav": {
        "tools": {
          "showAll": "Alle Tools anzeigen"
        }
      },
      "startPage": {
        "greeting": "Hallo {user}!",
        "greetingFallback": "Hallo!",
        "subtitle": "Willkommen bei fobizz.",
        "welcomeBack": "Willkommen zurück.",
        "news": {
          "headline": "Neuigkeiten",
          "linkLabel": "Alle Neuigkeiten anzeigen"
        },
        "toTeach": {
          "label": "Material | Materialien",
          "linkLabel": "to teach: {count} Material, in neuem Tab öffnen | to teach: {count} Materialien, in neuem Tab öffnen"
        }
      }
    }
  }
}
